import styled from "styled-components";

export const HeaderOne = styled.h1.attrs({
  className: "text-2xl leading-7 font-chivo-black" as string,
})``;

export const HeaderTwo = styled.h2.attrs({
  className: "text-xl leading-6 font-chivo-bold text-center" as string,
})``;

export const HeaderThree = styled.h3.attrs({
  className: "text-2base leading-5 font-chivo-regular" as string,
})``;

export const HeaderFour = styled.h4.attrs({
  className: "text-2.5xl leading-7 font-bold font-chivo-light" as string,
})``;
